import FormArchives from '../../DAL/FormArchives'
import {store} from '../utilities'
import {clear, category, activate} from '../action_creators'
import { getDoc, getDocs, collection, doc } from 'firebase/firestore'

export default function readForm(archiveId) {
  return function () {
    if (!archiveId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const archiveRef = formArchives.docRef(archiveId)
      const docSnap = await getDoc(archiveRef)
      if (!docSnap.exists()) return

      const formData = {order: [], ...docSnap.data(), id: docSnap.id}
      store.dispatch(category('form')(formData))

      const sectionIds = formData.order || []
      const fieldPromises = sectionIds.map((sectionId) =>
        getDocs(collection(archiveRef, 'sections', sectionId, 'fields'))
          .then((snap) => {
            const ff = {}
            snap.docs.forEach((d) => {
              ff[d.id] = {id: d.id, ...d.data()}
            })
            store.dispatch(category('fields')(ff))
          })
      )
      await Promise.all(fieldPromises)

      const state = store.getState()
      if (!state.active.section && sectionIds.length) {
        store.dispatch(activate('section', sectionIds[0]))
      }
    }
    fetch()
    return () => store.dispatch(clear())
  }
}
